
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return /^(9(324|391|807)|4(085|531|896)|(18|74)89|1545|2086|2188|5154|6041|6803|7875)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
